import { DateTime } from "luxon";

import Vue from "vue";

Vue.filter("yyyymd", function (value: string) {
  const dateLuxon = DateTime.fromISO(value);
  return dateLuxon.toLocaleString(DateTime.DATE_SHORT); // 2021/2/25
});
